import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-672c443e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex flex-column flex-root my-10 gradient",
  id: "kt_app_root"
}
const _hoisted_2 = { class: "d-flex flex-column flex-column-fluid flex-lg-row py-10" }
const _hoisted_3 = { class: "d-flex flex-column pt-10 me-5" }
const _hoisted_4 = { class: "d-flex mb-5" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "d-flex flex-center flex-lg-start flex-column pt-lg-5" }
const _hoisted_7 = { class: "d-flex flex-center pt-lg-5" }
const _hoisted_8 = { class: "d-flex flex-center flex-lg-start flex-column" }
const _hoisted_9 = { class: "text-gray-700 fs-3" }
const _hoisted_10 = { class: "d-flex flex-column justify-content-center justify-content-lg-end py-12" }
const _hoisted_11 = { class: "bg-white d-flex flex-column align-items-stretch flex-center rounded-top w-md-500px px-10" }
const _hoisted_12 = { class: "d-flex flex-center flex-column flex-column-fluid pb-5" }
const _hoisted_13 = {
  class: "form w-100",
  novalidate: "novalidate",
  id: "kt_sign_in_form"
}
const _hoisted_14 = { class: "row mt-10 mb-3" }
const _hoisted_15 = { class: "col-md-12" }
const _hoisted_16 = { class: "flex-center text-wrap fs-5 fw-bold text-gray-500" }
const _hoisted_17 = { class: "fv-row mb-2 fv-plugins-icon-container" }
const _hoisted_18 = { class: "d-grid mb-2" }
const _hoisted_19 = { class: "indicator-label" }
const _hoisted_20 = { class: "indicator-label" }
const _hoisted_21 = { class: "mt-3 text-center" }
const _hoisted_22 = { class: "mt-0 text-center" }
const _hoisted_23 = {
  key: 0,
  class: "text-info"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_25 = {
  key: 1,
  class: "text-white"
}
const _hoisted_26 = {
  class: "d-flex flex-stack pt-5 bg-white w-md-500px",
  style: {"border-top":"#E5E5E5 2px solid"}
}
const _hoisted_27 = { class: "d-flex fw-semibold text-primary fs-8 px-5" }
const _hoisted_28 = { class: "flex-center text-wrap w-100 text-gray-600" }
const _hoisted_29 = { class: "d-flex flex-start pt-lg-5 my-7" }
const _hoisted_30 = { class: "d-flex flex-column" }
const _hoisted_31 = { class: "text-white fs-4 fw-bold mb--5" }
const _hoisted_32 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center min-w-700px py-7\" data-v-672c443e><div class=\"overlay me-10\" data-v-672c443e><div class=\"overlay-wrapper\" data-v-672c443e><img alt=\"img\" class=\"rounded w-100px\" src=\"/media/microsoft.png\" data-v-672c443e></div><div class=\"overlay-layer bg-dark bg-opacity-10 rounded\" data-v-672c443e></div></div><div class=\"overlay me-10\" data-v-672c443e><div class=\"overlay-wrapper p-7\" data-v-672c443e><img alt=\"img\" class=\"rounded w-100px\" src=\"/media/pride.png\" data-v-672c443e></div><div class=\"overlay-layer bg-dark bg-opacity-10 rounded\" data-v-672c443e></div></div><div class=\"overlay me-10\" data-v-672c443e><div class=\"overlay-wrapper\" data-v-672c443e><img alt=\"img\" class=\"rounded w-100px\" src=\"/media/nubank.png\" data-v-672c443e></div><div class=\"overlay-layer bg-dark bg-opacity-10 rounded\" data-v-672c443e></div></div><div class=\"overlay\" data-v-672c443e><div class=\"overlay-wrapper\" data-v-672c443e><img alt=\"img\" class=\"rounded w-100px\" src=\"/media/stone.png\" data-v-672c443e></div><div class=\"overlay-layer bg-dark bg-opacity-10 rounded\" data-v-672c443e></div></div></div>", 1)

import {Actions} from "@/store/enums/StoreEnums";
import { useRoute } from "vue-router";
import {computed, ref} from "vue";
import { useI18n } from 'vue-i18n';
import {useStore} from "vuex";
import { AxiosResponse} from "axios";
import ApiService from "@/core/services/ApiService";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const { t } = useI18n();
const route = useRoute();
const validation_id = ref();
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));
const certificate = computed(() => store.getters.getCertificateResponse);
const statusVerify = ref(false);
const verified = ref(false);
const code = ref(0);

if (route.query.id) {
  validation_id.value = route.query.id
}
// const lengthValidation = computed(() => {
//   return validation_id.value?.length > 35
// });

const bagCertificate =  (language: string) =>{
  if (language === 'en'){
    return '/media/certificate/bag-certificate-eng.png'
  }else if(language === 'es'){
    return '/media/certificate/bag-certificate-esp.png'
  }else {
    return '/media/certificate/bag-certificate-pt.png'
  }
}

let timeout1, timeout2, timeout3;

const clearPreviousTimeouts = () => {
  clearTimeout(timeout1);
  clearTimeout(timeout2);
  clearTimeout(timeout3);
};

const makeStatusVerifyTrue = () => {
  statusVerify.value = true;
  timeout1 = setTimeout(() => {
    statusVerify.value = false;
    makeVerifiedTrue();
  }, 1000);
};

const makeVerifiedTrue = () => {
  verified.value = true;
  timeout2 = setTimeout(() => {
    makeRedirectTrue();
  }, 1500);
};

const makeRedirectTrue = () => {
  timeout3 = setTimeout(() => {
    verified.value = false;
    const appUrl = window.location.origin;
    window.open(`${appUrl}/certificate/${validation_id.value}`, '_blank');
  },1000);
}
const verifyCertificate = async () => {
  clearPreviousTimeouts();
  statusVerify.value = true;
  try {
    await store.dispatch(Actions.VERIFY_CERTIFICATE, validation_id.value);
    if (certificate.value?.status === 200) {
      makeStatusVerifyTrue();
      code.value = 1;
    } else {
      code.value = 2;
    }
  } catch (e) {
    console.error('Error verifying certificate:', e);
  } finally {
    statusVerify.value = code.value === 1;
    verified.value = false;
  }
};

const messageVerify = computed(() => {
  if (code.value === 1) {
    return {
      color: 'text-success',
      text: t(`${currentLanguage.value}.profile_public.certificate.certificate_verified_successfully`)
    }
  } else if (code.value === 2) {
    return {
      color: 'text-danger',
      text: t(`${currentLanguage.value}.profile_public.certificate.certification_denied`)
    }
  } else {
    return {
      color: 'text-white',
      text: '-'
    }
  }
});

const buttonVerify = computed(() => {
  if (statusVerify.value) {
    return {
      text:   t(`${currentLanguage.value}.profile_public.certificate.verifying`),
      bg: 'btn btn-light',
      status: false
    }
  } else if (verified.value) {
    return {
      text: t(`${currentLanguage.value}.profile_public.certificate.verified`),
      bg: 'btn btn-light',
      status: false
    }
  } else if (validation_id.value?.length < 36) {
    return {
      text: t(`${currentLanguage.value}.profile_public.certificate.verify`),
      bg: 'btn btn-light',
      status: false
    }
  } else if (validation_id.value === undefined) {
    return {
      text: t(`${currentLanguage.value}.profile_public.certificate.verify`),
      bg: 'btn btn-light',
      status: false
    }
  }else {
    return {
      text: t(`${currentLanguage.value}.profile_public.certificate.verify`),
      bg: 'btn btn-hc',
      status: true
    }
  }
});

const lengthValidation = computed(() => {
    return (validation_id.value?.length < 36 || validation_id.value === undefined) ? 'text-danger' : 'text-gray-600';
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: bagCertificate(_unref(currentLanguage)),
            alt: "",
            class: "align-items-lg-start"
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h2", {
            class: _normalizeClass(["text-white fw-bold", _unref(currentLanguage) === 'en' ? 'fz-2' : 'fs-3hx'])
          }, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.profile_public.certificate.100_practical_certifications_with_an_emphasis_on_techniques`)), 3)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.profile_public.certificate.title_desc`)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("form", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.profile_public.certificate.form_title`)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "Ex: ****-*****-****",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((validation_id).value = $event)),
                  maxlength: "36",
                  class: _normalizeClass([_unref(lengthValidation), "form-control bg-transparent border-gray-500 text-gray-500"])
                }, null, 2), [
                  [_vModelText, validation_id.value]
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass([_unref(lengthValidation), "fs-9"])
                  }, "36/" + _toDisplayString(validation_id.value?.length ?? 0), 3)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                (_unref(buttonVerify).status)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: verifyCertificate,
                      class: _normalizeClass(_unref(buttonVerify).bg)
                    }, [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(buttonVerify).text), 1)
                    ], 2))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(_unref(buttonVerify).bg)
                    }, [
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(buttonVerify).text), 1)
                    ], 2)),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("p", {
                    class: _normalizeClass(["font-weight-bold", _unref(messageVerify).color])
                  }, _toDisplayString(_unref(messageVerify).text), 3)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  (verified.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                        _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.profile_public.certificate.opening_certificate`)) + " ", 1),
                        _hoisted_24
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_25, "."))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.profile_public.certificate.footer_form`)) + " Crowsec EdTech LTDA-38.056.645/0001-19 ", 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.profile_public.certificate.our_students_work_in`)), 1),
        _hoisted_32
      ])
    ])
  ]))
}
}

})